import React, { Fragment } from 'react'

import { useUnit } from 'effector-react'

import { useMediaQueries } from 'hooks'

import { palette } from 'helpers/palette'

import AllCenter from 'components/_old/AllCenter/AllCenter.jsx'
import Button from 'components/_old/Button/Button.jsx'
import Icon from 'components/_old/Icon/Icon.jsx'
import { Typo } from 'components/_old/Typo'
import Width from 'components/_old/Width/Width'

import { MobileLayout, MobileLayoutFooterButton } from 'components/atoms/Layouts'
import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { Modal } from 'components/molecules/Modal'

import { $isSuccessModalOpen, handleSuccessFinish } from '../../model'
import { $isWetSignatureRequired } from '../../model/formModel'

export const SuccessModal = (): React.ReactElement => {
  const { desktop } = useMediaQueries()
  const [isOpen, isWetSignatureRequired, handleFinish] = useUnit([
    $isSuccessModalOpen,
    $isWetSignatureRequired,
    handleSuccessFinish,
  ])

  const title = isWetSignatureRequired
    ? 'The ISA transfer form has been sent to your email'
    : 'The ISA transfer request has been submitted successfully'

  const description = isWetSignatureRequired
    ? 'Please check your inbox.\n\nThere you can find the download link and further instructions.'
    : `Please check your inbox.\n\nThere you can find the further instructions.`

  const content = (
    <Fragment>
      <AllCenter>
        <Icon type="checkmark_in_a_circle" color={palette['status-success']} size={64} data-test-id="successIcon" />
      </AllCenter>
      <Paper top={desktop ? 16 : 32} bottom={40}>
        <Typography size={desktop ? 32 : 24} weight="semibold" lineHeight="small" align="center">
          <Typo>{title}</Typo>
        </Typography>
      </Paper>
      <Paper bottom={96}>
        <Typography size={16} lineHeight="small" align="center">
          <Typo multiline>{description}</Typo>
        </Typography>
      </Paper>
    </Fragment>
  )

  const button = (
    <Button mods={{ size: 'big block' }} onClick={handleFinish}>
      Continue
    </Button>
  )

  if (desktop)
    return (
      <Modal open={isOpen} onClose={handleFinish}>
        <Width size={36}>
          <Paper top={96} bottom={64} left={64} right={64}>
            {content}
            {button}
          </Paper>
        </Width>
      </Modal>
    )

  return (
    <Modal open={isOpen} onClose={handleFinish}>
      <MobileLayout
        content={<Paper top={32}>{content}</Paper>}
        footer={<MobileLayoutFooterButton>{button}</MobileLayoutFooterButton>}
      />
    </Modal>
  )
}
